import React, { lazy, ComponentType, Suspense } from 'react';
import LoadingProgress from '@components/LoadingProgress';
const EventScheduler = lazy(
  () => import('@features/EventScheduler/components/EventScheduler'),
);
import { useClientSpecificEventProvider } from '@hooks/clientSpecificUtils';
import { env } from 'env';

const withMytaverseEventProviders = <T,>(
  WrappedComponent: ComponentType<T>,
) => {
  const clientSpecificEventProvider = useClientSpecificEventProvider();

  return (props: T) => {
    let Component = <WrappedComponent {...props} />;
    if (env.REACT_APP_FEATURE_EVENT_SCHEDULER === 'true') {
      Component = (
        <>
          <Suspense fallback={<LoadingProgress />}>
            <EventScheduler />
          </Suspense>
          <WrappedComponent {...(props as T)} />
        </>
      );
    }

    return clientSpecificEventProvider(Component);
  };
};
export default withMytaverseEventProviders;
